import TableRow from '@material-ui/core/TableRow';

/** @deprecated */
export default TableRow;
